import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M790.588235,1468.23529 C416.865882,1468.23529 112.941176,1164.31059 112.941176,790.588235 C112.941176,416.865882 416.865882,112.941176 790.588235,112.941176 C1164.31059,112.941176 1468.23529,416.865882 1468.23529,790.588235 C1468.23529,1164.31059 1164.31059,1468.23529 790.588235,1468.23529 L790.588235,1468.23529 Z M1387.36941,1307.52 C1507.76471,1168.82824 1581.17647,988.235294 1581.17647,790.588235 C1581.17647,354.748235 1226.42824,2.84217094e-14 790.588235,2.84217094e-14 C354.748235,2.84217094e-14 2.84217094e-14,354.748235 2.84217094e-14,790.588235 C2.84217094e-14,1226.42824 354.748235,1581.17647 790.588235,1581.17647 C988.235294,1581.17647 1168.82824,1507.76471 1307.52,1387.36941 L1823.54824,1903.51059 L1903.51059,1823.54824 L1387.36941,1307.52 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionSearchLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionSearchLine, _Component);

  var _super = _createSuper(IconDiscussionSearchLine);

  function IconDiscussionSearchLine() {
    _classCallCheck(this, IconDiscussionSearchLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionSearchLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussionSearch",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDiscussionSearchLine.displayName = "IconDiscussionSearchLine";
  return IconDiscussionSearchLine;
}(Component);

IconDiscussionSearchLine.glyphName = 'discussion-search';
IconDiscussionSearchLine.variant = 'Line';
IconDiscussionSearchLine.deprecated = true;
IconDiscussionSearchLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionSearchLine;
export { IconDiscussionSearchLine };